module.exports = __webpack_public_path__ + "img/tu05.4873b1ae.jpg";